export default __webpack_public_path__ + "static/favicon-5021093e8740156ffa93e84a1e983406.ico";